import { type ReactElement } from 'react';

import { Link, type LinkProps } from '@mui/material';
import {
  Link as ReactRouterDomLink,
  type LinkProps as ReactRouterDomLinkProps,
} from 'react-router-dom';

export type RouterLinkProps = Omit<LinkProps, 'component'> &
  ReactRouterDomLinkProps;

export const RouterLink = (props: RouterLinkProps): ReactElement => (
  <Link component={ReactRouterDomLink} {...props} />
);
